/* eslint-disable @nx/enforce-module-boundaries */
import { useEffect, useContext, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  HStack,
  Text,
  Box,
  FormControl,
  FormLabel,
  Textarea,
  FormHelperText,
  FormErrorMessage,
} from '@mybridge/ui';
import { MyNetworkContext } from 'v4/components/network/context';
import { CheckGreen } from '@mybridge/icons';
import { getUserFullName } from 'v4/lib/commons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

const HandshakeUserModal = () => {
  const [addNoteSection, setAddNoteSection] = useState(false);
  const [customMessage, setCustomMessage] = useState(null);
  const {
    handshakeSelectedUser,
    setHandshakeSelectedUser,
    handshakeMessageDisc,
    handshakeUser, handshakeLoading
  } = useContext(MyNetworkContext);
  const { t } = useTranslator();

  return (
    <Modal {...handshakeMessageDisc} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontWeight="600" fontSize="20px">
          {addNoteSection
            ? `${t('eventDashboard.invite') || "Invite"} ${getUserFullName(handshakeSelectedUser)} ${t('otherModules.to_connect') || "to connect"}`
            : t('otherModules.extra_mile_pays') || 'It always pays to go the extra mile'}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {addNoteSection ? (
            <>
              <Text color="#868585" mb={3}>
                {t('otherModules.build_quality_network') || "Build a quality network by connecting only with people you know."}
              </Text>
              <FormControl isInvalid={customMessage?.length > 120 ? true : false}>
                <FormLabel color="#3D5A80">{t('otherModules.message_optional') || "Message (optional)"}</FormLabel>
                {/* <Textarea
                  bg="#F8F8F8"
                  border="1px solid #DDDDDD"
                  onChange={(e) => setCustomMessage(e.target.value)}
                  maxLength="120"
                ></Textarea> */}
                <Textarea
                  bg="#F8F8F8"
                  border="1px solid #DDDDDD"
                  value={customMessage || ""}  
                  onChange={(e) =>
                    setCustomMessage(
                      e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1)
                    )
                  }
                  maxLength="120"
                />
                <HStack w="100%" justifyContent="space-between">
                  {customMessage?.length > 120 ? <FormErrorMessage>
                  {t('otherModules.limit_exceeded') || "You have exceeded the limit"}
                  </FormErrorMessage> : <Box></Box>}  
                </HStack>
                <FormHelperText textAlign="right">
                  {customMessage?.length > 0 ? customMessage?.length : 0} / 120
                </FormHelperText>
              </FormControl>
            </>
          ) : (
            <HStack>
              <Box width="30px" height="30px">
                <CheckGreen width="24" height="24" />
              </Box>

              <Text color="#868585">
                {getUserFullName(handshakeSelectedUser)} {t('otherModules.personalized_note_tip') || "deserves a personalized note! Plus it's a great way to begin networking with this potential new connection."}
              </Text>
            </HStack>
          )}
        </ModalBody>
        <ModalFooter>
          {addNoteSection ? (
            <Button
              variant="secondary"
              color="brandPrimary.500"
              borderRadius="full"
              me={3}
              onClick={() => setAddNoteSection(false)}
            >
              {t('buttons.cancel') || "Cancel"}
            </Button>
          ) : (
            <Button
              variant="secondary"
              color="brandPrimary.500"
              borderRadius="full"
              me={3}
              onClick={() => setAddNoteSection(true)}
            >
              {t('otherModules.add_a_note') || "Add a note"}
            </Button>
          )}
          <Button
            variant="primary"
            borderRadius="full"
            onClick={() => handshakeUser(handshakeSelectedUser, customMessage)}
            isDisabled={handshakeLoading}
          >
            {t('buttons.send') || "Send"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default HandshakeUserModal;
